/* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import HoverSplash from './hoverSplash';

type PropsType = {
  p: {
    audio?: [],
    link_label: string,
    id: number
  }
};

const Audio = (props: PropsType): React.Element<'div'> => {
  const { p } = props;

  return (
    <div className={`splash-section splash-section-sounds ${p.background_color === 'Light' ? 'splash_section_light' : 'splash_section_dark'}`} id={`${_.toLower(p.link_label)}${p.id}`}>
      <div className="splash-container">
        {
          <>
            {_.map(
              _.sortBy(p.audio, (_p: {}): number => _p.placement_index),
              (af: {}, afi: number): React.Elemnt<'div'> => {
              return (
                <div className="splash-iframe" key={`p.audio-${afi}`}>
                  <iframe
                    frameBorder="0"
                    style={{
                      width: '100%',
                      height: '166px'
                    }}
                    src={`${process.env.SOUNDCLOUD_PAYER_URL}?url=${af.url}`}
                  />
                </div>
              );
            })}
          </>
        }
      </div>
      <HoverSplash {...props} />
    </div>
  );
};

export default Audio;
